import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Input } from 'antd';
import Styles from './corp-verify-code.module.scss';
import { apiHolder as api, apis } from 'api';
import { getIn18Text } from 'api';
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
function getVerifyCodeUrl(accountName, accountDomain, sid) {
    return loginApi.getVerifyCodeUrl(accountName, accountDomain, sid);
}
const VerifyCode = React.forwardRef(({ accountName, accountDomain, sid, onChange, onVerifyCodeLoadError }, ref) => {
    let [verifyCodeUrl, setVerifyCodeUrl] = useState();
    useEffect(() => {
        updateVerifyCode();
    }, [accountName, accountDomain, sid]);
    const updateVerifyCode = () => {
        if (accountName && accountDomain && sid) {
            let newVerifyCodeUrl = getVerifyCodeUrl(accountName, accountDomain, sid);
            setVerifyCodeUrl(newVerifyCodeUrl);
        }
    };
    useImperativeHandle(ref, () => {
        return {
            refreshVerifyImgCode() {
                updateVerifyCode();
            },
        };
    });
    const handleVerifyCodeError = () => {
        onVerifyCodeLoadError();
    };
    return (React.createElement("div", null,
        React.createElement(Input, { onChange: ev => {
                onChange && onChange(ev.target.value);
            }, placeholder: getIn18Text('QINGSHURUYANZHENG'), suffix: React.createElement("img", { alt: getIn18Text('YANZHENGMA'), title: getIn18Text('DIANJISHUAXINYAN'), className: Styles.corpVerifyCode, onError: handleVerifyCodeError, src: verifyCodeUrl, onClick: updateVerifyCode }) })));
});
export default VerifyCode;
